import CryptoJS from "crypto-js";


// export const decryptData = (combinedValue) => {

//   const secretKey = process.env.AES_SECRET_KEY
//   console.log("SE ",secretKey)
//   const [ivBase64, encryptedValue] = combinedValue.split(':');
//   const iv = Buffer.from(ivBase64, 'base64');  // Decode the IV from Base64

//   // Decrypt the value using AES-CBC
//   const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(secretKey), iv);
//   let decrypted = decipher.update(encryptedValue, 'base64', 'utf8');
//   decrypted += decipher.final('utf8');

//   return decrypted;
// };

export const decryptData = (combinedValue) => {

  console.log("Combined Value:", combinedValue); // Log the combined value

  const secretKey = process.env.REACT_APP_SECRET_KEY;
  console.log("SE ", secretKey);

  // Split the combined value into IV (Base64) and encrypted data
  const [ivBase64, encryptedValue] = combinedValue.split(':');

  console.log("IV Base64:", ivBase64);
  console.log("Encrypted Value:", encryptedValue);

  // Decode the IV from Base64 using CryptoJS
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  console.log("Decoded",iv);
  // Decrypt the value using AES-CBC with CryptoJS
  const decrypted = CryptoJS.AES.decrypt(encryptedValue, CryptoJS.enc.Utf8.parse(secretKey), { iv });
  console.log("DECRYPT",decrypted);
  // Convert the decrypted data to a string
  console.log("DEC",decrypted.toString(CryptoJS.enc.Utf8));
  return decrypted.toString(CryptoJS.enc.Utf8);
};


export const encryptPayload = async (payload) => {
    const encryptedPayload = {};
    const secretKey = process.env.REACT_APP_SECRET_KEY
    const h = "ksd"

    console.log("SE K ",secretKey,typeof(secretKey),h,typeof(h))

    // Iterate over the keys and encrypt each value with a unique IV
    for (let key in payload) {
      if (payload.hasOwnProperty(key)) {
        // Generate a random IV for each key
        const iv = CryptoJS.lib.WordArray.random(16);  // 16 bytes IV
  
        // Encrypt each value using AES-CBC
        const encryptedValue = CryptoJS.AES.encrypt(payload[key], CryptoJS.enc.Utf8.parse(secretKey), { iv }).toString();
  
        // Combine IV and encrypted value into a single value (separated by ':')
        const combinedValue = iv.toString(CryptoJS.enc.Base64) + ':' + encryptedValue;
  
        // Store the combined value
        encryptedPayload[key] = combinedValue;
      }
    }
  
    return encryptedPayload;
};
